import { CheckCircle2, KeyRound, PlugZap, RefreshCw, TriangleAlert } from 'lucide-react'

import { Button, StatusMessage } from '@krp/ui-kit'

import type { OneCDiagnosticsActions, OneCDiagnosticsVm } from '../model/types'
import '../../../shared/ui/onec.css'

/**
 * Диагностика одной базы 1С: профиль без секретов и проверка связи по кнопке.
 * Текст 1С — дословно (ADR-8). Пароль сюда не приходит ни в каком виде.
 */
export function OneCDiagnosticsPanel({ vm, actions }: { vm: OneCDiagnosticsVm; actions: OneCDiagnosticsActions }) {
  const { profile, check } = vm
  const error = profile.query.error
  return (
    <div className="onec-diagnostics">
      {profile.query.status === 'loading' || profile.query.status === 'idle' ? (
        <StatusMessage kind="loading" title="Профиль базы загружается…" />
      ) : profile.value === null ? (
        <StatusMessage
          kind={profile.query.status === 'forbidden' ? 'forbidden' : profile.query.status === 'unavailable' ? 'unavailable' : 'error'}
          title="Профиль базы не получен"
          text={error?.message}
          {...(error !== null && error.correlationId !== null
            ? { meta: `Код: ${error.code} · запрос ${error.correlationId}` }
            : {})}
          action={
            <Button variant="secondary" icon={<RefreshCw size={16} aria-hidden="true" />} onClick={actions.reload}>
              Повторить
            </Button>
          }
        />
      ) : (
        <dl>
          <dt>Информационная база</dt>
          <dd>{profile.value.infobase}</dd>
          <dt>Конфигурация</dt>
          <dd>{profile.profileTitle}</dd>
          <dt>Ревизия настроек</dt>
          <dd>{profile.value.configurationVersion}</dd>
          <dt>Шаблон создания товаров</dt>
          <dd>{profile.value.creationTemplateConfigured ? 'задан' : 'не задан'}</dd>
          <dt>Права службы</dt>
          <dd>{profile.value.capabilities.join(', ') || 'нет'}</dd>
        </dl>
      )}

      <Button icon={<PlugZap size={16} aria-hidden="true" />} busy={check.busy} onClick={actions.check}>
        Проверить связь с 1С
      </Button>
      {check.result !== null && (
        <p role="status" className="onec-diagnostics__result" data-outcome={check.result.outcome}>
          {check.result.outcome === 'reachable' ? (
            <CheckCircle2 size={16} aria-hidden="true" />
          ) : check.result.outcome === 'unauthorized' ? (
            <KeyRound size={16} aria-hidden="true" />
          ) : (
            <TriangleAlert size={16} aria-hidden="true" />
          )}{' '}
          <strong>{check.result.title}</strong>
          {check.result.remoteStatus !== null ? ` (HTTP ${check.result.remoteStatus})` : ''}
          {check.result.message !== null && <span> — {check.result.message}</span>}
          {check.result.outcome === 'unauthorized' && (
            <small>
              {' '}
              Повторная проверка тем же паролем не отправляется в 1С: смените учётные данные в форме ресурса.
            </small>
          )}
        </p>
      )}
      {check.error !== null && (
        <div role="alert">
          <strong>Проверка не выполнена.</strong> {check.error.message}{' '}
          <small>
            Код: {check.error.code}
            {check.error.correlationId !== null ? ` · запрос ${check.error.correlationId}` : ''}
          </small>
        </div>
      )}
    </div>
  )
}
